import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import { compose } from 'ramda';

import { getLabelMessage } from '@gef-ui/localization/messages';

import { codelistProvider } from 'components';
import OutputTextField from 'components/atoms/GefMui/OutputTextField';
import SectionHeader from 'components/atoms/GefMui/SectionHeader';
import { codelists } from 'constants/codelists';
import { FIELDS } from 'features/views/campaignSettings/startupCurve/form';
import { getCodelistPropById } from 'utils';

export const CampaignInfo = ({ campaignChannels, campaignStates, campaignDetail }) => (
	<Paper sx={{ p: 3, borderRadius: 2 }}>
		<Stack spacing={2}>
			<SectionHeader text={getLabelMessage('startupCurve:startupCurveHeading')} />
			<Grid container>
				<Grid size={12}>
					<Grid container spacing={2}>
						<Grid size={4}>
							<OutputTextField
								size="small"
								id={FIELDS.channel}
								label={getLabelMessage('startupCurve:channel')}
								fullWidth
								value={getCodelistPropById(campaignDetail.channelId, campaignChannels)}
								slotProps={{
									inputLabel: {
										shrink: !!campaignDetail.channelId,
									},
								}}
							/>
						</Grid>
						<Grid size={4}>
							<OutputTextField
								size="small"
								id={FIELDS.state}
								label={getLabelMessage('startupCurve:state')}
								fullWidth
								value={getCodelistPropById(campaignDetail.campaignStateId, campaignStates)}
								slotProps={{
									inputLabel: {
										shrink: !!campaignDetail.campaignStateId,
									},
								}}
							/>
						</Grid>
						<Grid size={4}>
							<OutputTextField
								size="small"
								id={FIELDS.communicationName}
								label={getLabelMessage('startupCurve:communicationName')}
								fullWidth
								value={campaignDetail.communicationName}
								slotProps={{
									inputLabel: {
										shrink: !!campaignDetail.communicationName,
									},
								}}
							/>
						</Grid>
					</Grid>
				</Grid>
			</Grid>
		</Stack>
	</Paper>
);

CampaignInfo.propTypes = {
	campaignChannels: PropTypes.arrayOf(PropTypes.object),
	campaignDetail: PropTypes.object,
	campaignStates: PropTypes.arrayOf(PropTypes.object),
};

export default compose(
	codelistProvider(codelists.campaignChannels, 'campaignChannels'),
	codelistProvider(codelists.campaignStates, 'campaignStates'),
)(CampaignInfo);
